import * as React from "react";

import { getRTL } from "@fluentui/react/lib/Utilities";

import { AppBaseButton } from "@1js/acui-button";
import { dataUniqueId } from "@1js/acui-common";
import { AppContext } from "@1js/acui-context";
import { checkExperiment, ribbonExperiments } from "@1js/acui-experiments";
import { iconNameToIconProps } from "@1js/acui-icons";
import { AppTooltipHost } from "@1js/acui-tooltip";

import { AppPaddleButtonProps } from "./AppPaddleButton.Props";
import { getPaddleButtonStyles } from "./AppPaddleButton.styles";

export class AppPaddleButton extends React.PureComponent<AppPaddleButtonProps> {
  private tooltipHost: AppTooltipHost | undefined;
  private baseButton = React.createRef<AppBaseButton>();

  // This allows us to access AppContext directly from this.context
  static contextType: any = AppContext;
  declare context: React.ContextType<typeof AppContext>;

  public render() {
    return (
      <AppBaseButton
        ref={this.baseButton}
        label={this.props.label}
        styles={getPaddleButtonStyles(
          this.props.orientation,
          getRTL(),
          this.props.disableModeTogglePadding ||
            !checkExperiment(
              this.context,
              ribbonExperiments.multilineRibbonIsEnabled
            )
        )}
        data-unique-id={dataUniqueId(this.props)}
        iconProps={iconNameToIconProps(this.props.icon)}
        onClick={this.onExecute}
        tabIndex={-1}
        data-is-focusable={false}
        ariaLabel={this.props.label}
        takeFocusOnClick={false}
      />
    );
  }

  public componentDidMount() {
    this.initializeTooltipHost();
  }

  public componentWillUnmount() {
    if (this.tooltipHost) {
      this.tooltipHost.unregisterTooltipHostActions();
    }
  }

  private initializeTooltipHost() {
    if (this.context.setTooltipElement && this.context.updateTooltipsHidden) {
      this.tooltipHost = new AppTooltipHost({
        updateTooltipsHidden: this.context.updateTooltipsHidden,
        setTooltipElement: this.context.setTooltipElement,
        refElement: this.baseButton,
        controlId: this.props.id,
        controlLabel: this.props.label,
        tooltipDirection: this.props.tooltipDirection,
        performSetOnNextFrame: !!checkExperiment(
          this.context,
          ribbonExperiments.delayRenderTooltipsIsEnabled
        ),
      });
      this.tooltipHost.registerTooltipHostActions();
    }
  }

  private onExecute = () => {
    this.props.onExecute(this.props.id);
  };
}
